import * as route from '../constants/routes';

export const mainMenuItems = [
  ['Home', route.HOME_PATH],
  ['About', route.ABOUT_PATH],
  ['Services', route.SERVICES_PATH],
  ['Staff', route.STAFF_PATH],
];
